// api - https://developers.intercom.com/installing-intercom/web/installation/
export const state = () => ({
  init: false,
  loading: false,
})

export const mutations = {
  set_init(state, payload) {
    state.init = payload
  },
  set_loading(state, payload) {
    state.loading = payload
  },
}

export const actions = {
  root_userData({ rootGetters }) {
    const user = rootGetters['user/user']
    return !user?.id
      ? {}
      : {
        name: `${user?.firstname} ${user?.lastname}`,
        email: user?.email,
        user_id: user?.intercom_id,
        tel: `${user?.phone_code}  ${user?.phone}`,
      }
  },
  async init({ commit, state , dispatch }) {
    if (state.init) return
    const intercomId = this.$config.intercomId
    const intercomApi = this.$config.intercomApi
    if (!intercomId || !intercomApi) return
    commit('set_init', true)
    commit('set_loading', true)
    window.addEventListener('userLogout',() => {
      try {
        window.Intercom('shutdown')
        delete window.intercomSettings.name
        delete window.intercomSettings.email
        delete window.intercomSettings.user_id
        delete window.intercomSettings.tel
        window.Intercom('boot', {
          api_base: intercomApi,
          app_id: intercomId,
          hide_default_launcher: true,
        })
      }
      catch (err) {
        console.error('intercom error: ',err)
      }
    })
    window.addEventListener('userLogin', async () => {
      try {
        const userInfo = await dispatch('root_userData')
        window.Intercom('update', userInfo)
        window.Intercom('hide')
      }
      catch (err) {
        console.error('intercom error: ',err)
      }
    })
    try {
      const script = document.createElement('script')
      script.addEventListener('load', () => {
        window.Intercom('onShow', () => {
          commit('set_loading', false)
        })
        window.Intercom('show')
      })
      script.src = `https://widget.intercom.io/widget/${intercomId}`
      document.body.appendChild(script)
      const userInfo = await dispatch('root_userData')
      window.intercomSettings = {
        api_base: intercomApi,
        app_id: intercomId,
        hide_default_launcher: true,
        ...userInfo,
      }
    }
    catch (err) {
      commit('set_init', false)
      commit('set_loading', false)
      console.error('intercom error: ',err)
    }
  },
  intercom_open( { state, dispatch }, f = () => {}) {
    f()
    try {
      state.init
        ? window.Intercom('show')
        : dispatch('init')
    }
    catch (err) {
      console.error('intercom/open ', err)
    }
  },
}
export const getters = {
  get_loading: (state) => state.loading,
}
